import { makeObservable, observable } from 'mobx';
import { API } from '~/api';
import { GridStateModel } from '~/model/model.gridstate';
import { TranslationModel } from '~/model/model.translation';
import { OlfactiveCreateDto } from '~/shared/dto/admin/olfactive.dto';
import { Async } from '~/shared/tools/async';
import { Singleton } from '../shared/service/service.base';
import { ApiService } from './service.api';

@Singleton()
export class OlfactiveService {
	readonly items = observable.array([] as API.OlfactiveListItem[], { deep: false });
	readonly gridState = new GridStateModel('olfactive');
	readonly async = new Async();

	@observable.ref names: API.OlfactiveName[] = [];
	@observable totalCount = 0;

	constructor(
		private api: ApiService,
		readonly tr: TranslationModel,
	) {
		makeObservable(this);
	}

	loadAndSubscribe = () => {
		this.reload();
		return this.gridState.subscribe(this.reload);
	};

	reload = () => {
		this.async.call(async () => {
			const { data } = await this.api.olfactiveGetList({
				limit: this.gridState.pageSize,
				offset: this.gridState.offset,
				filter: this.gridState.filter,
				sort: this.gridState.sort,
				sortDir: this.gridState.sortDir,
			});
			return () => {
				this.items.replace(data.items);
				this.totalCount = data.total;
			};
		});
	};

	getOne = async (id: number | undefined) => {
		if (id === undefined) return;
		return this.async.exec(() => this.api.olfactiveGetOne(id).then(resp => resp.data));
	};

	save = (id: number | undefined, data: OlfactiveCreateDto) => {
		return this.async.exec(async () => {
			data.image = await this.api.uploadImg(data.image);
			if (id === undefined) await this.api.olfactiveCreate(data);
			else await this.api.olfactiveUpdate(id, data);
		});
	};

	delete = async (id: number) => {
		return await this.async.exec(() => this.api.olfactiveDelete(id)).then(this.reload);
	};

	fetchNames = () => {
		this.async.call(async () => {
			const { data } = await this.api.olfactiveGetNames();
			return () => (this.names = data.items);
		});
	};
}
